import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';

export class DracoManager {
	static instance;

	static instantiated = false;
	static activeUsers = [];

	static createInstance() {
		DracoManager.instance = new DRACOLoader().setDecoderPath(
			'https://www.gstatic.com/draco/versioned/decoders/1.5.6/',
		);
	}

	constructor() {}

	getInstance() {
		if (!DracoManager.instantiated) {
			DracoManager.createInstance();
			DracoManager.instantiated = true;
		}
		return DracoManager.instance;
	}

	dispose() {
		if (!DracoManager.instantiated) return;

		let idx = DracoManager.activeUsers.indexOf(this);
		DracoManager.activeUsers.splice(idx, 1);

		if (!DracoManager.activeUsers.length) {
			DracoManager.instance.dispose();
			DracoManager.instance = null;
			DracoManager.instantiated = false;
		}
	}

	setActive() {
		DracoManager.activeUsers.push(this);
	}
}
